exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wl-m-select[data-v-573d865f] {\n  width: 100%;\n}\n.wl-title[data-v-573d865f] {\n  height: 0.25rem;\n}", ""]);

// exports
